import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const TriggersPage = async () => import('@/pages/TriggersPage.vue');
const TriggerFormPage = async () => import('@/pages/TriggerFormPage.vue');

export default function getTriggersRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'triggers',
      component: TriggersPage,
      meta: {
        title: 'Triggers',
        useIn: ['navigation-tabs'],
      },
      path: '/triggers',
    },
    {
      name: 'create-trigger',
      component: TriggerFormPage,
      meta: {
        title: 'Create trigger',
      },
      path: '/triggers/create',
      props: (): {
        action: CrudAction;
      } => ({
        action: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      name: 'edit-trigger',
      component: TriggerFormPage,
      meta: {
        title: 'Edit trigger',
      },
      path: String.raw`/triggers/edit/:id(\d+)`,
      props: (
        route,
      ): {
        action: CrudAction;
      } => ({
        action: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-trigger',
      component: TriggerFormPage,
      meta: {
        title: 'Clone trigger',
      },
      path: String.raw`/triggers/clone/:id(\d+)`,
      props: (
        route,
      ): {
        action: CrudAction;
      } => ({
        action: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
